import {
    ApplicationConfig,
    DEFAULT_CURRENCY_CODE,
    importProvidersFrom,
    inject,
    LOCALE_ID,
    PLATFORM_ID
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { routes } from './app.routes';
import { provideApollo as provideApollo_alias } from 'apollo-angular';
import { ApolloLink, DefaultOptions, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { onError } from '@apollo/client/link/error';
import { authInterceptor } from "./core/auth/auth.interceptor";
import Swal from "sweetalert2";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { MatPaginatorIntl } from "@angular/material/paginator";
import { getCustomPaginatorIntl } from "./core/custom-paginator-intl";
import {MAT_DATE_LOCALE, MatNativeDateModule, provideNativeDateAdapter} from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgxMaskConfig, provideNgxMask } from "ngx-mask";
import { environment } from "../environments/environment";

registerLocaleData(localePt);

const maskConfig: Partial<NgxMaskConfig> = {
    validation: true,
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideNativeDateAdapter(),
        provideHttpClient(withInterceptors([authInterceptor])),
        HttpLink,
        importProvidersFrom(MatNativeDateModule), // here
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR' // pt-BR | en-US | es-ES
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'BRL' // BRL | USD | EUR
        },
        provideApollo_alias(() => {
            const platformId = inject(PLATFORM_ID);
            const httpLink = inject(HttpLink);

            if (!isPlatformBrowser(platformId)) {
                return {
                    cache: new InMemoryCache(),
                };
            }

            const errorLink = onError(({ graphQLErrors, networkError }) => {
                if (graphQLErrors) {
                    graphQLErrors.forEach(({ message, locations, path }) => {
                        // console.error(`[GraphQL Error]: Mensagem: ${message}, Local: ${locations}, Caminho: ${path}`);
                        console.log('message');
                        console.log(message);
                        const elError: any = graphQLErrors[0];
                        if (elError?.extensions?.originalError?.statusCode === 401) {
                            localStorage.clear();
                            window.location.href = '/login';
                        } else {
                            Swal.fire({
                                title: 'Atenção',
                                html: message,
                                icon: 'warning',
                                confirmButtonText: 'OK',
                            });
                        }
                    });
                }
                if (networkError) {
                    console.error(`[Network Error]: ${networkError}`);
                }
            });

            const defaultOptions: DefaultOptions = {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'none',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'none',
                },
                mutate: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'none',
                },
            };

            return {
                link: ApolloLink.from([
                    errorLink,
                    httpLink.create({ uri: environment.base_graphql }),
                ]),
                cache: new InMemoryCache(),
                defaultOptions,
            };
        }),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    // darkModeSelector: '.app-dark',
                    cssLayer: {
                        name: 'primeng',
                        order: 'theme, base, primeng'
                    }
                }
            }
        }),
        { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl() },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        provideNgxMask(maskConfig),
    ],
};
